import * as React from "react";
import {CSSProperties} from "react";

import {faPlus} from "@fortawesome/free-solid-svg-icons/faPlus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {ConditionGroup} from "./ConditionGroup";
import {StoreAutoIncrement, StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {ComparisonTypeEnum} from "./Comparators/ComparatorBase";
import {ConditionLineTypeEnum} from "./Comparators/ComparatorFactory";


export class ConditionBuilder extends React.Component<ConditionBuilderProps, ConditionBuilderState> {
    static defaultProps: Partial<ConditionBuilderProps> = {};
    public ConditionGroups:ConditionGroup[];
    constructor(props: ConditionBuilderProps) {
        super(props);
        this.ConditionGroups=[];

        this.state = {};
    }

    componentDidMount() {

    }

    protected NoFilterMessage()
    {
        return (
            <div style={{textAlign:'center'}}>
                <p style={{margin:0}}>You haven't create any filter yet (which means the pdf will be always attached to the selected emails)</p>
                <button onClick={()=>this.CreateGroup()} className={'rnbtn rnbtn-primary'} style={{marginTop:5,display:'inline-flex',alignItems:'center'}}>
                    <FontAwesomeIcon icon={faPlus} style={{marginRight:3}}/> Click here to add your first filter
                </button>
            </div>
        )

    }
    public render() {
        this.ConditionGroups=new Array(this.props.Condition.ConditionGroups.length);
        if(this.ConditionGroups.length==0)
        {
            return this.NoFilterMessage()
        }

        return (
            <div style={{marginTop:15,...this.props.Styles}}>
                {
                    this.props.Condition.ConditionGroups.map((group,index)=>
                        <div  key={group.Id} style={{marginBottom:10}}>
                            <ConditionGroup ref={node=>{if(node!=null)this.ConditionGroups[index]=node}} OnFieldChanged={()=>this.RecalculateElementsUsed()} OnRemoveGroup={()=>this.RemoveGroup(group)} ConditionBuilder={this} ConditionGroup={group}/>
                            {index<this.props.Condition.ConditionGroups.length-1?<span style={{fontWeight:"bold"}}>or</span>:null}
                        </div>
                    )
                }

                <div style={{marginTop:10}}>
                    {this.props.Condition.ConditionGroups.length > 0 &&
                    <label style={{fontWeight:"bold"}}>or</label>
                    }
                    <div style={{marginTop:10}}>
                        <button onClick={x=>{x.preventDefault();this.CreateGroup()}} className={'rnbtn rnbtn-primary'}>Add new group</button>
                    </div>
                </div>
            </div>
        )
    }



    public get Options(){
        return this.props.Condition;
    }

    protected CreateGroup() {
        this.props.Condition.ConditionGroups.push(new ConditionGroupOptions().Merge({ConditionLines:[{} as any]}));
        this.forceUpdate();
    }

    private RemoveGroup(group: ConditionGroupOptions) {
        let index=this.props.Condition.ConditionGroups.indexOf(group);
        if(index<0)
            return;

        this.props.Condition.ConditionGroups.splice(index,1);
        this.RecalculateElementsUsed();
        this.forceUpdate();
    }

    private RecalculateElementsUsed() {
        this.Options.ElementsUsed=[];
        for(let group of this.Options.ConditionGroups)
            for(let line of group.ConditionLines)
            {
                if(line.Type==ConditionLineTypeEnum.Standard)
                    this.Options.ElementsUsed.push(new ElementUsedOptions().Merge({Type:ElementUsedTypeEnum.Field,Id:line.FieldId}));

            }


    }

    Validate() {

        for (const item of this.ConditionGroups) {
            if(!item.Validate())
                return false;
        }
        return true;
    }
}



//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface ConditionBuilderProps {
    Condition:ConditionOptionsBase;
    Styles:CSSProperties;
    Fields:any[];
}

interface ConditionBuilderState {

}
export enum ElementUsedTypeEnum{
    Field='Field'
}

export enum ConditionTypeEnum {
    Filter='ShowHide'
}

export class ElementUsedOptions extends StoreBase{
    public Type:ElementUsedTypeEnum;
    public Id:any;

    protected LoadDefaultValues() {
        this.Type=ElementUsedTypeEnum.Field;
        this.Id='';
    }

}



export class ConditionLineOptions extends StoreBase{
    public FieldId:string;
    public PathId:string;

    public Comparison:ComparisonTypeEnum;
    public Value:any;
    public Type:ConditionLineTypeEnum;
    public SubType:String;


    @StoreAutoIncrement('ConditionLineOptions')
    public Id:number;
    protected LoadDefaultValues() {
        this.Id=0;
        this.FieldId='';
        this.Comparison=ComparisonTypeEnum.None;
        this.Value='';
        this.Type=ConditionLineTypeEnum.None;
        this.SubType="None";
        this.PathId='';
    }


    protected GetValueFromLoader(property, value: any): any {
        switch (property)
        {
            case 'Value':
                return ConditionLineValueFactory.GetValue(this,value);
            default:
                return value;
        }
    }
}


export class ConditionGroupOptions extends StoreBase{
    @StoreAutoIncrement('ConditionGroupOptions')
    public Id:number;
    @StoreDataType(ConditionLineOptions)
    public ConditionLines:ConditionLineOptions[];
    protected LoadDefaultValues() {
        this.ConditionLines=[];
        this.Id=0;
    }

}


export class ConditionOptionsBase extends StoreBase{
    @StoreAutoIncrement('ConditionOptionsBase')
    public Id:number;
    public Type:ConditionTypeEnum;
    @StoreDataType(ConditionGroupOptions)
    public ConditionGroups:ConditionGroupOptions[];
    @StoreDataType(ElementUsedOptions)
    public ElementsUsed:ElementUsedOptions[];

    protected LoadDefaultValues() {
        this.Id=0;
        this.Type=ConditionTypeEnum.Filter;
        this.ElementsUsed=[];
        this.ConditionGroups=[];
    }
}


export class ShowHideConditionOptions extends ConditionOptionsBase{
    public Title:string;
    @StoreDataType(Number)
    public Fields:number[];
    public ShowWhenTrue:boolean;
    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Title='Show Hide Condition';
        this.Fields=[];
        this.ShowWhenTrue=true;
    }
}


class ConditionLineValueFactory{
    public static GetValue(Condition:ConditionLineOptions,value:any){
        if(Condition.SubType=="Multiple")
        {
            if(value==''||!Array.isArray(value))
                return [];
        }

        return value;
    }
}


//#endregion "My Region"